export const LIMITED_MODE = window.RCN_LIMITED_MODE === true;
export const INDIVIDUAL_ZOOM_THRESHOLD = 14;
export const PARCEL_LAYERS_MIN_ZOOM = 15;
export const OVERLAY_LAYERS_MIN_ZOOM = PARCEL_LAYERS_MIN_ZOOM;
export const MAP_MAX_ZOOM = 20;
export const DESKTOP_LAYOUT_BREAKPOINT = 1100;
export const OPENFREEMAP_STYLE = 'https://tiles.openfreemap.org/styles/bright';
export const DEFAULT_LAT = 52.0;
export const DEFAULT_LNG = 19.5;
export const DEFAULT_ZOOM = 6;
export const MAP_REFRESH_DEBOUNCE_MS = 280;
// A map refresh activates up to ~10 data layers; firing every layer's API call in
// one tick sends a burst of parallel requests that can saturate PHP-FPM workers.
// Stagger successive calls by this many ms (the first stays immediate so the
// refresh feels instant). Small enough to be imperceptible per layer.
export const API_REFRESH_STAGGER_MS = 70;
export const BBOX_DECIMALS = 4;

// Map data accumulation: instead of wiping every layer on each map move, fetched
// features are merged into a per-layer client-side store so pans append rather
// than replace. Growth is bounded by viewport-distance eviction + a hard cap.
// The cap sits above the largest single-viewport API response (signals return
// up to 5000 features) so a dense viewport is never truncated; the
// viewport-distance eviction keeps the practical count far lower while panning.
export const ACCUMULATOR_MAX_FEATURES = 6000;
// Padding factor applied to the viewport when deciding which accumulated
// features to keep. 1.0 = pad 100% on each side, i.e. keep ~3x the viewport span.
export const ACCUMULATOR_VIEWPORT_KEEP_FACTOR = 1.0;
export const LIST_PER_PAGE = 20;
export const DEFAULT_SORT = 'tran_wersja_id';
export const VALID_TABS = ['list', 'details', 'nearby', 'filters'];
export const VALID_ASSETS = ['dzialki', 'lokale', 'budynki'];
export const VALID_SORTS = ['tran_wersja_id', 'cena_brutto', 'price_per_m2', 'powierzchnia'];
export const PANEL_COLLAPSED_STORAGE_KEY = 'rcn-newmobile-panel-collapsed';
export const BASE_URL = typeof window.RCN_NEWMOBILE_URL === 'string' ? window.RCN_NEWMOBILE_URL : '/';
export const TERYT_URL = typeof window.RCN_TERYT_POWIATY_URL === 'string' ? window.RCN_TERYT_POWIATY_URL : 'api/teryt-powiaty';
export const MIEJSCOWOSCI_URL = window.RCN_MIEJSCOWOSCI_SEARCH_URL || '/api/miejscowosci-search';
export const PRG_GEOMETRY_URL = window.RCN_PRG_GEOMETRY_URL || '/api/prg-geometry';
export const DZIALKI_SEARCH_URL = window.RCN_DZIALKI_SEARCH_URL || '/api/dzialki-search';
export const EGIB_DZIALKI_SEARCH_URL = window.RCN_EGIB_DZIALKI_SEARCH_URL || '/api/egib-dzialki-search';
export const EGIB_BUDYNKI_SEARCH_URL = window.RCN_EGIB_BUDYNKI_SEARCH_URL || '/api/egib-budynki-search';
export const DZIALKA_ID_PARAM = 'dzialka_id';

const initialQueryParams = new URLSearchParams(window.location.search || '');

export const GEOPORTAL_BASE_URL = 'https://mapy.geoportal.gov.pl/imap/Imgp_2.html';
export const RCN_BASE_URL = 'https://mapy.geoportal.gov.pl/imapnext/imap/index.html?moduleId=modulRCN';
export const MAPVIEW_SCALE = '1000s';
export const PERF_DEBUG = initialQueryParams.get('perf') === '1';
export const PARCEL_RENDER_MODE = initialQueryParams.get('parcel_mode') === 'vector' ? 'vector' : 'geojson';
export const GUNB_ROK_WPLYWU_OD_PARAM = 'gunb_rok_wplywu_od';
export const TRANSACTION_ROK_OD_PARAM = 'rok_od';
export const BDOT10K_IMPACT_CLASSIFICATION_PARAM = 'bdot10k_impact_classification';
export const BDOT10K_NUISANCE_LEVEL_PARAM = 'bdot10k_nuisance_level_min';
export const BDOT10K_USEFULNESS_LEVEL_PARAM = 'bdot10k_usefulness_level_min';
export const DEFAULT_TRANSACTION_ROK_OD = '2023';
export const DEFAULT_GUNB_ROK_WPLYWU_OD = '2025';
export const YEAR_FILTER_EMPTY_URL_VALUE = '0';
export const GUNB_EMPTY_FILTER_URL_VALUE = '0';

export const BDOT10K_IMPACT_CLASSIFICATION_LABELS = {
    harmful: 'Uciążliwy',
    neutral: 'Neutralny',
    useful: 'Użyteczny'
};

export const NIER = {
    nieruchomoscGruntowaNiezabudowana: 'Grunt niezabudowany',
    nieruchomoscGruntowaZabudowana: 'Grunt zabudowany',
    nieruchomoscLokalowa: 'Lokal'
};

export const RODZ = {
    wolnyRynek: 'Wolny rynek',
    sprzedazBezprzetargowa: 'Bezprzetargowa',
    sprzedazPrzetargowa: 'Przetargowa',
    sprzedazWPostepowaniuEgzekucyjnym: 'Egzekucyjna',
    sprzedazZBonifikata: 'Z bonifikatą',
    sprzedazNaCelPubliczny: 'Cel publiczny'
};

export const TYP = { 1: 'Działka', 2: 'Lokal', 3: 'Budynek' };

export const FUNKCJA = {
    mieszkalna: 'mieszkalna',
    garaz: 'garaż',
    inne: 'inne',
    handlowoUslugowa: 'handlowo-usługowa',
    biurowa: 'biurowa',
    produkcyjna: 'produkcyjna'
};

export const WOJ_SLUGS = {
    '02': 'dolnoslaskie',
    '04': 'kujawsko-pomorskie',
    '06': 'lubelskie',
    '08': 'lubuskie',
    '10': 'lodzkie',
    '12': 'malopolskie',
    '14': 'mazowieckie',
    '16': 'opolskie',
    '18': 'podkarpackie',
    '20': 'podlaskie',
    '22': 'pomorskie',
    '24': 'slaskie',
    '26': 'swietokrzyskie',
    '28': 'warminsko-mazurskie',
    '30': 'wielkopolskie',
    '32': 'zachodniopomorskie'
};

export const BDOT10K_LAYER_LABELS = {
    OT_BUBD_A: 'Budynki',
    OT_BUZT_A: 'Zbiorniki',
    OT_BUIT_A: 'Budowle inżynierskie',
    OT_KUPG_A: 'Przemysł i gospodarka',
    OT_KUKO_A: 'Komunikacja',
    OT_KUIK_A: 'Zakłady specjalne',
    OT_KUOS_A: 'Oświata',
    OT_KUOZ_A: 'Ochrona zdrowia',
    OT_KUSC_A: 'Obiekty sakralne i cmentarze',
    OT_KUSK_A: 'Sport i rekreacja',
    OT_KUZA_A: 'Kultura i zabytki',
    OT_KUHO_A: 'Hotele i turystyka',
    OT_OISZ_A: 'Obiekty specjalne'
};

export const BDOT10K_FUNOGBUD_LABELS = {
    budynekGospodarstwaRolnego: 'Budynek gospodarstwa rolnego',
    budynekZabytkowy: 'Budynek zabytkowy',
    budynkiBiurowe: 'Budynki biurowe',
    budynkiGarazy: 'Garaże',
    budynkiHandlowoUslugowe: 'Budynki handlowo-usługowe',
    budynkiHoteli: 'Hotele',
    budynkiKultuReligijnego: 'Budynki kultu religijnego',
    budynkiKulturyFizycznej: 'Budynki kultury fizycznej',
    budynkiMieszkalneJednorodzinne: 'Budynki jednorodzinne',
    budynkiMuzeowIBibliotek: 'Muzea i biblioteki',
    budynkiODwochMieszkaniach: 'Budynki dwumieszkaniowe',
    budynkiOTrzechIWiecejMieszkaniach: 'Budynki wielorodzinne',
    budynkiPrzemyslowe: 'Budynki przemysłowe',
    budynkiSzkolIInstytucjiBadawczych: 'Szkoły i instytuty badawcze',
    budynkiZbiorowegoZamieszkania: 'Budynki zbiorowego zamieszkania'
};
